"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _reactRedux = require("react-redux");
var _commonI18n = require("@mmc/common-i18n");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _configuratorModelSelector = _interopRequireDefault(require("../styles/configurator-model-selector.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  isEmptyArray = dataUtils.isEmptyArray;
var ModelCardDetails = function ModelCardDetails(_ref) {
  var engineSize = _ref.engineSize,
    fuelType = _ref.fuelType,
    drivetrain = _ref.drivetrain,
    transmissionType = _ref.transmissionType,
    engineType = _ref.engineType,
    price = _ref.price,
    displayValue = _ref.displayValue,
    zeroMessage = _ref.zeroMessage,
    theme = _ref.theme,
    config = _ref.config,
    technicalDetails = _ref.technicalDetails,
    prefix = _ref.prefix,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData,
    descriptionList = _ref.descriptionList;
  var hasZeroMessage = typeof zeroMessage === 'string' && zeroMessage.length > 1;
  var getTrimConfigDetails = function getTrimConfigDetails() {
    if (technicalDetails && !isEmptyArray(technicalDetails)) {
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: theme.bodyCopy + " " + _configuratorModelSelector["default"].techDetails
      }, technicalDetails.map(function (detail) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: "detail-" + detail
        }, detail);
      }));
    }
    if (descriptionList && !isEmptyArray(descriptionList)) {
      return descriptionList.map(function (description) {
        return /*#__PURE__*/_react["default"].createElement(_text.Text, {
          text: "\u2022 " + description,
          tag: "span",
          className: theme.bodyCopy,
          disclaimerData: disclaimerData
        });
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.bodyCopy
    }, engineSize + " " + fuelType, " \u2022 ", drivetrain, " ", transmissionType), /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.bodyCopy
    }, engineType));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorModelSelector["default"].modelDetails + " " + theme.marginTop10 + " " + theme.marginBottom20
  }, getTrimConfigDetails()), (price > 0 || hasZeroMessage) && /*#__PURE__*/_react["default"].createElement("span", {
    className: theme.inputsAndOptions + " " + _configuratorModelSelector["default"].modelDetailsPrice
  }, prefix && /*#__PURE__*/_react["default"].createElement("span", null, prefix + " "), /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: price,
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode'),
      displayValue: displayValue,
      zeroMessage: zeroMessage
    },
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: priceDisclaimerId,
    disclaimerData: disclaimerData
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(ModelCardDetails);
exports["default"] = _default;